import {
  SET_NAVIGATION_LINKS,
  SET_STATIC_CONTENT,
} from '../mutationTypes';

const moduleContent = {
  namespaced: true,

  state: {
    navigationLinks: [],
    staticContent: '',
  },

  getters: {

  },

  actions: {

  },

  mutations: {
    [SET_NAVIGATION_LINKS](state, payload) {
      state.navigationLinks = payload;
    },
    [SET_STATIC_CONTENT](state, payload) {
      state.staticContent = payload;
    },
  },
};

export default moduleContent;
